//APP CONFIG
var version = 'v1';
export const $appConfig = {
  endpoint: {
    baseUrl: getBaseUrl() + '/api/' + version,
    version: version,
    baseDomain: getBaseUrl(),
    baseFileDomain: "https://i.storage.ertebat.io",
    bucketName: getBucketName(),
    wordPressActive: isWordPressUpdateActive(),
    title: getSiteTitle(),
  },
  fp_api_key: "G9i0F6aIAINmM99dm0Tl"
}


function isWordPressUpdateActive() {
  var origin = window.location.origin;
  switch (origin) {

    case "https://admin.hamnafas.live":
      return true;

    case "https://dev.admin.hamnafas.live":
      return true;

    case "https://admin.bahaiat.hozeh.org":
      return true;

    case "https://admin.eslam.hozeh.org":
      return true;

    case "https://admin.farzaneh.hozeh.org":
      return true;

    case "https://admin.hamaseh.hozeh.org":
      return true;

    case "https://admin.majoosigari.hozeh.org":
      return true;

    case "https://admin.masihiat.hozeh.org":
      return true;

    case "https://admin.mehrab.hozeh.org":
      return true;

    case "https://admin.modir.hozeh.org":
      return true;

    case "https://admin.nemayeh.hozeh.org":
      return false;

    case "https://admin.omolmomenin.hozeh.org":
      return true;

    case "https://admin.rasoolerahmat.hozeh.org":
      return true;

    case "https://admin.sagha.hozeh.org":
      return true;

    case "https://admin.tooba.hozeh.org":
      return true;

    case "https://admin.vahabiat.hozeh.org":
      return true;

    case "https://admin.tohid.hozeh.org":
      return true;

    case "https://admin.shoara.hozeh.org":
      return true;

    case "https://admin.madinatolelm.hozeh.org":
      return true;

    case "https://admin.babolelm.hozeh.org":
      return true;

    case "https://admin.reyhaneh.hozeh.org":
      return true;

    case "https://admin.hafez.hozeh.org":
      return true;

    case "https://admin.lanejasoosi.hozeh.org":
      return true;

    case "https://admin.rahtoosheh.hozeh.org":
      return true;

    case "https://admin.isfahan.hozeh.org":
      return true;

    case "https://admin.safinatonejat.hozeh.org":
      return true;

    case "https://admin.shams.hozeh.org":
      return true;

    case "https://admin.mouood.hozeh.org":
      return true;

    default:
      return true;
  }
}

function getBucketName() {
  var origin = window.location.origin;
  switch (origin) {

    case "https://admin.hamnafas.live":
      return "hamnafas"

    case "https://dev.admin.hamnafas.live":
      return "devhamnafas"

    case "https://admin.bahaiat.hozeh.org":
      return "bahaiat.hozeh.org"

    case "https://admin.eslam.hozeh.org":
      return "eslam.hozeh.org"

    case "https://admin.farzaneh.hozeh.org":
      return "farzaneh.hozeh.org"

    case "https://admin.hamaseh.hozeh.org":
      return "hamaseh.hozeh.org"

    case "https://admin.majoosigari.hozeh.org":
      return "majoosigari.hozeh.org"

    case "https://admin.masihiat.hozeh.org":
      return "masihiat.hozeh.org"

    case "https://admin.mehrab.hozeh.org":
      return "mehrab.hozeh.org"

    case "https://admin.modir.hozeh.org":
      return "modir.hozeh.org"

    case "https://admin.nemayeh.hozeh.org":
      return "nemayeh.hozeh.org"

    case "https://admin.omolmomenin.hozeh.org":
      return "omolmomenin.hozeh.org"

    case "https://admin.rasoolerahmat.hozeh.org":
      return "rasoolerahmat.hozeh.org"

    case "https://admin.sagha.hozeh.org":
      return "sagha.hozeh.org"

    case "https://admin.tooba.hozeh.org":
      return "tooba.hozeh.org"

    case "https://admin.vahabiat.hozeh.org":
      return "vahabiat.hozeh.org"

    case "https://admin.tohid.hozeh.org":
      return "tohid.hozeh.org"

    case "https://admin.shoara.hozeh.org":
      return "shoara.hozeh.org"

    case "https://admin.madinatolelm.hozeh.org":
      return "madinatolelm.hozeh.org"

    case "https://admin.babolelm.hozeh.org":
      return "babolelm.hozeh.org"

    case "https://admin.reyhaneh.hozeh.org":
      return "reyhaneh.hozeh.org";

    case "https://admin.hafez.hozeh.org":
      return "hafez.hozeh.org";

    case "https://admin.lanejasoosi.hozeh.org":
      return "lanejasoosi.hozeh.org";

    case "https://admin.rahtoosheh.hozeh.org":
      return "rahtoosheh.hozeh.org";

    case "https://admin.isfahan.hozeh.org":
      return "isfahan.hozeh.org";

    case "https://admin.safinatonejat.hozeh.org":
      return "safinatonejat.hozeh.org";

    case "https://admin.shams.hozeh.org":
      return "shams.hozeh.org";

    case "https://admin.mouood.hozeh.org":
      return "mouood.hozeh.org";
    default:
      return "hamnafas"
  }
  
}

function getSiteTitle() {
  var origin = window.location.origin;
  switch (origin) {

    case "https://admin.hamnafas.live":
      return "همنفس"

    case "https://dev.admin.hamnafas.live":
      return "همنفس دولوپ"

    case "https://admin.bahaiat.hozeh.org":
      return "بهائيت"

    case "https://admin.eslam.hozeh.org":
      return "اسلام ناب"

    case "https://admin.farzaneh.hozeh.org":
      return "فرزانه"

    case "https://admin.hamaseh.hozeh.org":
      return "روایت حماسه"

    case "https://admin.majoosigari.hozeh.org":
      return "مجوسی گری"

    case "https://admin.masihiat.hozeh.org":
      return "مسیحیت"

    case "https://admin.mehrab.hozeh.org":
      return "مهراب"

    case "https://admin.modir.hozeh.org":
      return "مدیر"

    case "https://admin.nemayeh.hozeh.org":
      return "نمایه"

    case "https://admin.omolmomenin.hozeh.org":
      return "ام المومنین"

    case "https://admin.rasoolerahmat.hozeh.org":
      return "رسول رحمت"

    case "https://admin.sagha.hozeh.org":
      return "سقا"

    case "https://admin.tooba.hozeh.org":
      return "طوبی"

    case "https://admin.vahabiat.hozeh.org":
      return "وهابیت"

    case "https://admin.tohid.hozeh.org":
      return "توحید"

    case "https://admin.shoara.hozeh.org":
      return "دیوان شعرا"

    case "https://admin.madinatolelm.hozeh.org":
      return "مدینه العلم"

    case "https://admin.babolelm.hozeh.org":
      return "باب العلم"

    case "https://admin.reyhaneh.hozeh.org":
      return "ریحانه"

    case "https://admin.hafez.hozeh.org":
      return "حافظ"

    case "https://admin.lanejasoosi.hozeh.org":
      return "اسناد لانه جاسوسی"

    case "https://admin.rahtoosheh.hozeh.org":
      return "ره توشه"

    case "https://admin.isfahan.hozeh.org":
      return "اصفهان"

    case "https://admin.safinatonejat.hozeh.org":
      return "سفینه النجاه"

    case "https://admin.shams.hozeh.org":
      return "شمس الشموس"

    case "https://admin.mouood.hozeh.org":
      return "موعود"

    default:
      return "همنفس"
  }
}

function getBaseUrl() {
  var origin = window.location.origin;
  if (origin.startsWith('http://localhost') || origin.startsWith('https://localhost')) {
    // return 'https://api.nemayeh.hozeh.org';
    //return 'https://localhost:5001';
    return 'https://dev.api.hamnafas.live';
  }
  var url = origin.toLocaleLowerCase().replace("admin", "api");
  return url;
}

// export const $appConfig = {
//   endpoint:{
//     baseUrl : 'https://apimag.hozeh.org/api/v1',
//     version: '/v1',
//     baseDomain: 'https://apimag.hozeh.org/',
//     baseFileDomain: 'https://apimag.hozeh.org',
//   },
//   commentCount:0
// }